import en from "./en-US";
import it from "./it-IT";

export default {
  ...en,
  ...it,
};
